import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/goal-progress-calculator',
  component: () => import('../../routes/GoalProgressCalculator.svelte'),
  card: {
    id: 'goal-progress',
    title: 'Goal Progress Calculator',
    description: 'Track your savings goal progress, see how much you need to save monthly, and project when you\'ll reach your target.',
    icon: 'flag',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/goal-progress-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Goal Progress Calculator – Track Your Savings Milestones',
    description: 'Free goal progress calculator to track savings goals, calculate required monthly contributions, and project when you\'ll reach your financial target.',
  },
};

export default meta;
